import React from 'react';
import {Link} from 'react-router';
import ReactDataSheet from 'react-datasheet';
import FirebaseApi from '../../api/firebase'
import 'react-table/react-table.css'
import ReactTable from 'react-table'
import matchSorter from 'match-sorter'
import moment from 'moment'
import {connect} from 'react-redux';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import { renderToStaticMarkup } from 'react-dom/server';
import toastr from 'toastr';


class TeachersPage extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      teachers: [],
      loading:true,
      show: false,
      deleting_id: '',
    }
  }

  componentDidMount = () => {
    this.updateTeachers()
  }

  processTeacher = (teacherInfo, key) => {

    let contract_number = this.countContracts(teacherInfo)

    let processedTeacher = {
      name: teacherInfo.name,
      start_date:teacherInfo.start_date,
      id: key,
      rut: teacherInfo.rut,
      contract_number: contract_number
    }
    return processedTeacher

  }

  updateTeachers = () => {
    let teachers = []
    FirebaseApi.GetValues('/teachers').then( (snap) => {
      let teachersObj = snap.val()
      if(teachersObj) {
        Object.keys(teachersObj).forEach( (key) => {
          teachers.push(this.processTeacher(teachersObj[key], key))
        })
      }
      this.setState({teachers, loading: false})
    })
  }

  //WIP
  editTeacher = (teacher_id) => {
    FirebaseApi.GetValueByKeyOnce('teachers', teacher_id.value).then( (snap) => {
      let res = snap.val()
      if(res) {
        let teacher = {...res[Object.keys(res)[0]], id: Object.keys(res)[0]}
        this.props.setCurrentTeacher(teacher)
        this.props.history.push('/teacher')
      }
    })
  }

  confirmDeleteTeacher = (teacher_id) => {
    this.setState({ show: true , deleting_id: teacher_id.value})
  }

  sanitizeRut = (rut) => {
    let clean_rut = rut.split('.').join('')
    let number_rut = clean_rut.split('-')[0]
    let verification_digit = clean_rut.split('-')[1]
    let sanitized_rut_number = parseInt(number_rut).toString()
    let sanitized_rut = sanitized_rut_number + '-' +  verification_digit
    return sanitized_rut

  }

  deleteTeacher = () => {
    console.log('Deleting id: ' + this.state.deleting_id)
    /*FirebaseApi.GetValueByKeyOnce('teacher', this.state.deleting_id).then( (snap) => {
      let res = snap.val()
      if(res) {
        let teacher = {...res[Object.keys(res)[0]], id: Object.keys(res)[0]}
        let teacher_key = this.sanitizeRut(contract.rut)
        FirebaseApi.GetValueByKeyOnce('teachers', teacher_key).then((snap) => {
          let res = snap.val()
          let res_keys = Object.keys(res)
          let teacher = null
          res_keys.length > 0 ? teacher = res[res_keys[0]] :  null
          console.log(res)
          let school_teacher = teacher[contract.selectedOption.label]
          console.log(school_teacher)

          if(Object.keys(school_teacher).includes(this.state.deleting_id)) {
            console.log('deleting')
            FirebaseApi.RemoveChildByKey('teachers/' + teacher_key + '/' + contract.selectedOption.label, this.state.deleting_id).then((err ) => {
              FirebaseApi.RemoveChildByKey('/contracts', this.state.deleting_id).then( (error) => {
                this.setState({ show: false })
                this.updateContracts()
              })
            })

          }
        })
      }
    })*/
  }

  cancelDeleteTeacher = () => {
    this.setState({ show: false })
  }

  countContracts = (teacher_info) => {
    let counter = 0
    //console.log(<teacher_info></teacher_info>)
    if(teacher_info.contracts != null) {
      Object.keys(teacher_info.contracts).forEach( (school) => {
        Object.keys(teacher_info.contracts[school]).forEach(contract => {
          counter+= 1
        })
      })
    }

    return counter

  }

  newContract = (teacher_id) => {
    //We clear any previous contract info
    this.props.resetContractInfo()

    //We get the teacher for which we are making the new contract
    FirebaseApi.GetValueByKeyOnce('teachers', teacher_id.value).then( (snap) => {
      let res = snap.val()
      if(res) {
        let teacher = {...res[Object.keys(res)[0]], id: Object.keys(res)[0]}
        this.props.setCurrentTeacher(teacher)
        this.props.history.push('/home')
      }
    })

  }

  newTeacher = () => {
    this.props.resetTeacherInfo()
    this.props.history.push('/teacher')
  }

render() {
  return (

     <div className="jumbotron">
        <div className='new-contract-button-container'>
          <button className='btn btn-primary' onClick={() => this.newTeacher()}>Crear Nuevo Profesor</button>
        </div>
        <div className='flex'>
          <h1>Profesores</h1>
          <div className='title-spinner'  style={this.state.loading ? {display:'flex'} : {display:'none'} }>
            <i className="fas fa-circle-notch fa-spin fa-2x" aria-hidden="true"></i>
          </div>
        </div>
        <SweetAlert
          show={this.state.show}
          title="Confirmar"
          text={renderToStaticMarkup(<h5>¿Eliminar el anexo?</h5>)}
          html
          onConfirm={() => this.deleteContract()}
          onCancel = {() => this.cancelDeleteContract()}
          confirmButtonText= 'Eliminar'
          cancelButtonText= 'Cancelar'
          showCancelButton
        />
        <ReactTable
          data={this.state.teachers}
          filterable
          columns={[
            {
              Header: "Nombre",
              accessor: "name",
              id: 'name',
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["name"] }),
              filterAll: true
            },

            {
              Header: "Rut",
              accessor: "rut",
              className: 'centered-text-cell',
              id: "rut",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["rut"] }),
              filterAll: true
            },
            {
              Header: "Fecha de Contrato",
              className: 'centered-text-cell',
              accessor: "start_date",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["start_date"] }),
              filterAll: true,
              sortMethod: (a, b) => {
                let momentA = moment(a, 'DD-MM-YYYY')
                let momentB = moment(b, 'DD-MM-YYYY')

                return momentA.isSameOrBefore(momentB) ? 1 : -1;
              }
            },
            {
              Header: "Numero de anexos",
              accessor: "contract_number",
              className: 'centered-text-cell',
              id: "contract_number",
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, { keys: ["contract_number"] }),
              filterAll: true
            },
            {
              Header: '',
              accessor: "id",
              Cell: (value) => (
                <div className='centered-text flex space-around'>
                  <div>
                    <button className='btn btn-primary' onClick={() => this.editTeacher(value)}>
                      <i className="far fa-edit"></i>
                    </button>
                  </div>
                  <div>
                    <button className='btn btn-warning' onClick={() => this.newContract(value)}>
                     <i className="far fa-clipboard"></i>
                    </button>
                  </div>
                </div>
                ),
              Filter: () => (
                 ''
                ),
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    )
  }

}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentTeacher: (teacherInfo) => {
      dispatch({
        type: 'SET TEACHER INFO',
        teacherInfo: teacherInfo
      })
    },
    resetContractInfo: () => {
      dispatch({
        type: 'RESET CONTRACT INFO',
      })
    },
    resetTeacherInfo: () => {
      dispatch({
        type: 'RESET TEACHER INFO',
      })
    }

  };
}


export default connect(null, mapDispatchToProps)(TeachersPage);


// WEBPACK FOOTER //
// ./src/components/home/TeachersPage.js